import type * as React from 'react'

import { cn } from '@nwwp/ui-shadcn/lib/utils'

type DisclosureSlotProps = React.ComponentProps<'section'>

/**
 * Marked region for Compliance-approved disclosure copy.
 * Leave empty until Compliance fills it — do not draft legal text.
 */
function DisclosureSlot({ className, children, ...props }: DisclosureSlotProps) {
  // Don't render an empty labeled landmark (axe `region`) while awaiting Compliance copy.
  if (!children) return null

  return (
    <section
      data-slot="disclosure-slot"
      aria-label="Legal disclosures"
      className={cn(
        'rounded-lg border border-dashed border-border bg-muted/30 p-4 text-body-xs text-muted-foreground',
        className
      )}
      {...props}
    >
      {children}
    </section>
  )
}

export { DisclosureSlot }
export type { DisclosureSlotProps }
